import * as React from "react";
import SectionHeading from "src/components/general/SectionHeading";
import SingleCouncil from "./SingleCouncil";
import { connect } from "react-redux";
import { defaultYear } from "src/constants/ApiSettings";
import { IConnectedModuleProps, IConnectedModuleState } from "src/interfaces";
import { ICouncil } from "src/interfaces";
import axios from "axios";
import { baseUrl } from "src/constants/ApiSettings";
import * as qs from "query-string-for-all";

interface IPopData {
  growth: number;
  nonResidents: number;
  residents: number;
}

const EMPTY_IPOPDATA = {
  growth: 0,
  nonResidents: 0,
  residents: 0
}

interface IState extends IConnectedModuleState {
  scale: number;
  data: null | IPopData[];
}

class PeopleLivingIn extends React.PureComponent<
  IConnectedModuleProps,
  IState
> {
  public state: IState;
  constructor(props: IConnectedModuleProps) {
    super(props);

    const selectedYear = defaultYear;

    this.fetchScaleAndData = this.fetchScaleAndData.bind(this);

    const scale = 1;
    this.state = { 
      selectedYear, 
      scale, 
      data: null
    };
  }

  public handleYearChange = (value: string) => {
    this.setState({ selectedYear: value });
    this.fetchScaleAndData(this.props.councils, value);
  };

  public componentDidMount() {
    this.fetchScaleAndData(this.props.councils, this.state.selectedYear);
  }

  public componentWillReceiveProps(newProps: IConnectedModuleProps) {
    if (newProps.defaultYear !== this.state.selectedYear) {
      if (newProps.defaultYear !== null) {
        this.fetchScaleAndData(newProps.councils, newProps.defaultYear);
      }
    }
  }

  public async generateData(council: ICouncil, year: string){
    return axios
      .all([
        axios.get(
          `${baseUrl}/residentPopulationGrowth?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/nonResidentWorkforce?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/residentPopulation?${qs.stringify({
            council: council.id,
            year
          })}`
        )
      ])
      .then(
        axios.spread((resGrowth, resNonResWorkforce, resPopulation) => {
          const growth = this.round(resGrowth.data[0].value);
          const nonResidents = Math.round(resNonResWorkforce.data[0].value);
          const residents = Math.round(resPopulation.data[0].value);

          const tempData = {
            growth,
            nonResidents,
            residents
          };
          return tempData;
        })
      )
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  };

  /* tslint:disable */
  public async fetchScaleAndData(_councils: ICouncil[], year:string){
    const data: IPopData[] = [];
    let largestResidentCount = 0
    for await (const council of this.props.councils) {
      const item = await this.generateData(council, year) || EMPTY_IPOPDATA
      const idx = data.push(item) -1
      const sumResidents = data[idx].residents + data[idx].nonResidents
      if (sumResidents > largestResidentCount) {
        largestResidentCount = sumResidents
      }
    };
    // Math for getting people going
    const maxPeople = 20; // They had 40 in the demo so 🤷
    const roof = largestResidentCount;
    const scale = roof > maxPeople ? maxPeople / roof : 1;
    this.setState({
      ...this.state,
      data,
      scale
    })
  }

  public render() {
    if (this.state.data === null) {
      return null;
    };
    if (this.state.data[0] === undefined){
      return null;
    }
    const data = this.state.data
    // logA(this.state.data[0], "State in render")
    return (
      <div className="flex flex-wrap items-center justify-center content-center" id="population">
      
        <SectionHeading
          heading="People living in your council area"
          alignment="left"
          yearPicker={ this.handleYearChange }
          year={ this.state.selectedYear }
          learnMore={ "residentPopulation" }
          councilSays={ "residentPopulationCouncilSays" }
          inverse={ true }
        />

        {( this.state.data !== null ) && (

          <div 
            className="flex flex-wrap">
              {this.props.councils.map((council, index) => {
                if (this.state.data === null) {return null};
                return (
              
                <div 
                  key={index}
                  className="w-full md:w-1/2 lg:w-1/2 xl:w-1/2 items-center justify-between content-center mb-5">
                  <SingleCouncil
                    ordinal={index + 1}
                    council={council}
                    year={ this.state.selectedYear }
                    residents={data[index].residents}
                    nonResidents={data[index].nonResidents}
                    growth={data[index].growth}
                    people={data[index].residents * this.state.scale}
                    trans={data[index].nonResidents * this.state.scale}
                  />
                </div>
              
              )})}
          </div>

        )}
      </div>
    );
  }

  private round = (num: number) => {
    return Math.round(num * 100) / 100
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PeopleLivingIn);



// WEBPACK FOOTER //
// ./src/components/report/councilArea/PeopleLivingIn/index.tsx